/* =============================================================
   RESOURCE CENTER — rc.js
   Transcript toggle and minor UI behaviors.
   ============================================================= */

(function () {
  'use strict';

  function initTranscriptToggles() {
    document.querySelectorAll('.rc-transcript__toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        var body = btn.nextElementSibling;
        if (body) body.classList.toggle('is-open', !expanded);
      });
    });
  }

  function initTagFilters() {
    var blog = document.querySelector('.rc-blog');
    if (!blog) return;
    var filters = blog.querySelector('.rc-blog__filters');
    if (!filters) return;

    function setActiveFilter(href) {
      filters.querySelectorAll('.rc-blog__filter-btn').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.href === href);
      });
    }

    function swap(url, pushState) {
      var body = blog.querySelector('.rc-blog__body');
      body.classList.add('is-loading');
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newBody = doc.querySelector('.rc-blog__body');
          if (newBody) body.innerHTML = newBody.innerHTML;
          body.classList.remove('is-loading');
          if (pushState) history.pushState({}, '', url);
          setActiveFilter(url);
        })
        .catch(function () {
          body.classList.remove('is-loading');
        });
    }

    filters.addEventListener('click', function (e) {
      var btn = e.target.closest('.rc-blog__filter-btn');
      if (!btn) return;
      e.preventDefault();
      if (btn.classList.contains('is-active')) return;
      swap(btn.href, true);
    });

    window.addEventListener('popstate', function () {
      setActiveFilter(location.href);
      swap(location.href, false);
    });
  }

  function initLightbox() {
    var bodies = document.querySelectorAll('.rc-article__body');
    if (!bodies.length) return;

    var lb = document.createElement('div');
    lb.className = 'rc-lightbox';
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('role', 'dialog');
    lb.innerHTML = '<div class="rc-lightbox__backdrop"></div><button class="rc-lightbox__close" aria-label="Close">&times;</button><img class="rc-lightbox__img" src="" alt="">';
    document.body.appendChild(lb);

    var lbImg = lb.querySelector('.rc-lightbox__img');

    function open(img) {
      lbImg.src = img.src;
      lbImg.alt = img.alt;
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    lb.querySelector('.rc-lightbox__backdrop').addEventListener('click', close);
    lb.querySelector('.rc-lightbox__close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    bodies.forEach(function (body) {
      body.querySelectorAll('img').forEach(function (img) {
        img.style.cursor = 'zoom-in';
        img.addEventListener('click', function () { open(img); });
      });
    });
  }

  function boot() {
    initTranscriptToggles();
    initTagFilters();
    initLightbox();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
